<script setup lang="ts">
import {
  contactIconPaths,
  filledContactIcons,
  type ContactKind
} from '~/stores/contacts'

const props = defineProps<{ kind: ContactKind }>()
const isFilled = computed(() => filledContactIcons.includes(props.kind))
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    :class="isFilled ? 'fill-current' : 'fill-none'"
    :stroke="kind === 'whatsapp' ? 'none' : 'currentColor'"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path :d="contactIconPaths[kind]" />
    <circle v-if="kind === 'instagram'" cx="12" cy="12" r="3.6" />
    <circle
      v-if="kind === 'instagram'"
      cx="17.2"
      cy="6.8"
      r="1"
      fill="currentColor"
      stroke="none"
    />
  </svg>
</template>
